module.exports = __webpack_public_path__ + "img/selima-webfont.96aab509.svg";